import { useNavigate, useLocation } from 'react-router';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Button from '@components/Button';
import { Typography } from '@components/Typography';
import { useTranslation, useQueryParams } from '@hooks';
import { ExternalRoutes, RoutePath } from '@constants/routes';
import { Header, Logo, Text, Container } from './styles';

const ErrorPage = () => {
    const { t } = useTranslation();
    const params = useQueryParams();
    const navigate = useNavigate();
    const location = useLocation();
    const returnUrl = params.get('returnUrl');

    const onClickSupport = () => {
        window.open(ExternalRoutes.SupportForm, '_blank');
    };

    const onClickBack = () => {
        // INFO: If code crashed - redirect to the home page with hard reload
        if (location.pathname !== RoutePath.Error) {
            window.location.href = RoutePath.Home;
            return;
        }
        if (returnUrl) {
            navigate(decodeURIComponent(returnUrl));
        } else {
            navigate(RoutePath.Home);
        }
    };

    return (
        <Container>
            <Header>
                <Logo />
                <Typography
                    onClick={onClickBack}
                    variant="body2"
                    sx={{
                        color: 'var(--text-primary)',
                        display: 'flex',
                        alignItems: 'center',
                        position: 'absolute',
                        top: '56px',
                        cursor: 'pointer',
                    }}
                >
                    <ArrowBackIcon sx={{ marginTop: '1px', marginRight: '15px', fontSize: '20px' }} />
                    {t('buttons.back')}
                </Typography>
            </Header>

            <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                <Typography
                    variant="h3"
                    sx={{
                        margin: '0 0 30px',
                        textAlign: 'center',
                        lineHeight: '1.2 !important',
                        '@media only screen and (max-width: 330px)': {
                            marginTop: '70px',
                        },
                        '@media only screen and (max-width: 600px)': {
                            fontSize: '30px !important',
                        },
                    }}
                >
                    {t('ErrorsPages.titleSomethingWrong')}
                </Typography>
                <div style={{ display: 'block', textAlign: 'center' }}>
                    <Text>{t('ErrorsPages.textSomethingWrong')}</Text>
                    <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        sx={{
                            width: '420px',
                            '@media only screen and (max-width: 600px)': {
                                width: 'auto',
                            },
                        }}
                        onClick={onClickSupport}
                    >
                        {t('buttons.contact')}
                    </Button>
                </div>
            </div>
        </Container>
    );
};

export default ErrorPage;
